import React, {useEffect} from 'react'
import {Box, Typography} from "@mui/material";
import Subtitle from "../../components/Subtitle";
import {useTranslation} from "react-i18next";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";


const ImprintLayout = () =>{
    const {t} =useTranslation();
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/imprint",
            type:"pageView"
        }))
    }, []);
    return(
        <React.Fragment>
            <Box component="main">
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('navigation.imprint' as any)}
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_1')}
                </Typography>
                <Typography paragraph>
                    {t('general.tum')} <br/>
                    {t('general.zsk')} <br/>
                    {t('general.address')} <br/>
                    {t('general.post_code')} <br/>
                    <a href="mailto:info@zsk.tum.de">info@zsk.tum.de</a> <br/>
                    <a href="mailto:zsk.tum.de"> zsk.tum.de</a> <br/>
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_2')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_2')}
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_3')}
                </Typography>
                <Typography paragraph>
                    DE811193231 (gemäß § 27a Umsatzsteuergesetz)
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_3_2')}
                </Typography>
                <br/>
                <Typography paragraph>
                    {t('imprint.title_4')} <br/>
                    <a target="_blank" href="https://stmwk.bayern.de">stmwk.bayern.de</a><br/>
                    {t('imprint.description_4')} <br/>
                    <a target="_blank" href="https://stmuv.bayern.de">stmuv.bayern.de</a><br/>
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_5')}
                </Typography>
                <Typography paragraph>
                    Prof. Dr. Thomas Rötzer<br/>
                    {t('general.tum')}<br/>
                    Hans-Carl-v.-Carlowitz-Platz 2 <br/>
                    85354 Freising<br/>
                    <a href="mailto:thomas.roetzer@tum.de">thomas.roetzer@tum.de</a><br/>
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_6')}
                </Typography>
                <br/>
                <Typography paragraph>
                    Dr. Astrid Reischl<br/>
                    <a href="mailto:astrid.reischl@tum.de">astrid.reischl@tum.de</a><br/>
                    <br/>
                    Eleonora Franceschi<br/>
                    <a href="mailto:eleonora.franceschi@tum.de">eleonora.franceschi@tum.de</a><br/>
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_7')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_7')}<br/>
                    <a target="_blank" href="https://dwd.de">dwd.de</a><br/>
                </Typography>
                <Typography variant="h6">
                    {t('imprint.title_8')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_8')}
                    <a target="_blank" href="https://cagatayakinbaser.net"> Çağatay Akin
                        Başer</a><br/> {t('imprint.description_8_2')}
                    <a target="_blank"
                       href="https://it.tum.de/it/it-servicezentrum/organisation">it.tum.de/it/it-servicezentrum/organisation</a>
                    <br/>
                    {t('general.contact')}: <a href="mailto:c.akinbaser@hotmail.com">c.akinbaser@hotmail.com</a><br/>
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_9')}
                </Typography>
                <Typography paragraph>
                    Monika Bradatsch<br/>
                    <a href="mailto:monika.bradatsch@tum.de">monika.bradatsch@tum.de</a><br/>
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_10')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_10')}<br/>
                    <a target="_blank" href="https://baumportal.de">baumportal.de </a><br/>
                    <a target="_blank" href="https://pixabay.com">pixabay.com </a><br/>
                    <a target="_blank" href="https://unsplash.com">unsplash.com</a><br/>
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_11')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_11')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_11_2')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_11_3')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_11_4')}
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_12')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_12_1')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_12_2')}
                </Typography>
                <br/>
                <Typography variant="h6">
                    {t('imprint.title_13')}
                </Typography>
                <Typography paragraph>
                    {t('imprint.description_13')}
                </Typography>
            </Box>
        </React.Fragment>
    )
}
export default ImprintLayout
